import { useCallback, useState } from "react";
import Lightbox from "@/components/gallery/Lightbox";

export function useLightbox(screens) {
  const [index, setIndex] = useState(null);
  const open = useCallback((i) => setIndex(i), []);
  // fromUi: closed via button/ESC → drop the history entry we pushed
  const close = useCallback((fromUi) => {
    setIndex(null);
    if (fromUi && window.history.state?.waidLightbox) window.history.back();
  }, []);
  const viewer =
    index === null ? null : <Lightbox screens={screens} index={index} onChange={setIndex} onClose={close} />;
  return { open, viewer };
}
